import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
	slider: Yup.array().of(
		Yup.object().shape({
			image: Yup.mixed().required().label('Image'),
		})
	),
});

const Inputs = [
	{
		name: 'hotGames',
		label: 'HotGames',
		type: 'select',
		value: 'multiple',
		valueAttr: 'hotGames',
		isPicker: true,
		required: true,
		hideInput: true
	},
	{
		name: 'slider',
		label: 'Slider',
		type: 'nestedArray',
		value: 'multiple',
		reOrder: "reOrder",
		valueAttr: 'slider',
		columns: [
			{
				name: 'image',
				label: 'Image',
				type: 'image',
				value: 'single',
				valueAttr: 'image',
				required: true,
				defaultValue: '',
				transform: (path: string) => {
					console.log(path);
					const safePath = path.replace(" ","%20");
					if (path?.includes?.('blob')) {
						return safePath;
					}
					return process.env.VUE_APP_ASSETS_URL + '/' + safePath;
				},
			},
			
			{
				name: 'sliderGame',
				label: 'Games',
				type: 'select',
				value: 'single',
				valueAttr: 'sliderGame',
				isPicker: true,
				required: true,
				relationshipName: 'games',
				hideSelect: true,
			},
			{
				name: 'startTime',
				label: 'Start Date',
				type: 'date',
				value: 'single',
				valueAttr: 'startTime',
				
			},
			{
				name: 'endTime',
				label: 'End Date',
				type: 'date',
				value: 'single',
				valueAttr: 'endTime',				
				
			},
		],
	}

];

export { Inputs, validationSchema };


